module.exports = __webpack_public_path__ + "static/media/DogTrack2.d2892425.png";